import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated blog posts list.
 * Supports two modes:
 * - Infinity scroll (default): auto-loads pages as user scrolls
 * - Pagination mode: traditional previous/next page navigation
 */
export default class BlogPostsList extends PaginatedList {
  connectedCallback() {
    // In pagination mode, skip the infinity scroll setup entirely.
    // Navigation is handled by the server-rendered <a> links.
    if (this.dataset.paginationMode === 'true') return;

    super.connectedCallback();
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
